import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OwnerActionMenuService {
  userMenuIsOpen = false;
  userMenuIsOpenObservable: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  closeUserMenu(): void {
    if (this.userMenuIsOpen) {
      this.userMenuIsOpen = false;
      this.userMenuIsOpenObservable.emit(this.userMenuIsOpen);
    }
  }

  toggleUserMenu(): void {
    this.userMenuIsOpen = !this.userMenuIsOpen;
    this.userMenuIsOpenObservable.emit(this.userMenuIsOpen);
  }

  closeAll(): void {
    this.closeUserMenu();
  }
}
